// extracted by mini-css-extract-plugin
export default {"tabsWrapper":"VnlPtKlX","mobile":"mobile","scroller":"KqDbuPYv"};